import { Alert, Spin } from "antd";
import { useSelector } from "react-redux";
import CheckPermission from "../../Util/CheckPermission";

const PermissionRoute = ({ requiredPermissions, children }) => {
  const userData = useSelector((state) => state.userData);

  if (!userData) return <Spin />;

  return requiredPermissions.every((permission) =>
    CheckPermission(permission, userData.permissions)
  ) ? children : <Alert type="warning" message="شما دسترسی به این بخش را ندارید." showIcon />;
};

export default PermissionRoute;
